import hasDowngraded from "./SuccessPage/utils/hasDowngraded";
import classNames from "classnames";
import Info1 from "../../../components/LandingTypography/assets/info_1.svg";
import convertSecondsToDaysToDays from "../utils/convertSecondsToDays";
import React from "react";
import useIsDesktop from "../../../hooks/useIsDesktop";
import withTranslations from "../../../../../../hocs/withTranslations";
import { compose } from "redux";

const DowngradeInfo = ({ paymentDetails, translate, className }) => {
  const isDesktop = useIsDesktop();
  const hasSubscription = paymentDetails?.has_subscription;

  return hasDowngraded({ paymentDetails }) ? (
    <div
      className={classNames(
        "bg-yellow-1 border-black-1 border py-3 px-4 w-full rounded-lg flex gap-4 align-center",
        { "mb-8": isDesktop, "mb-5": !isDesktop }
      )}
    >
      <img src={Info1} alt={""} />
      <p
        className={classNames("text-xs text-black m-0 text-black-8", className)}
        dangerouslySetInnerHTML={{
          __html: hasSubscription
            ? translate("success-page_downgrade-paragraph_subscription", {
                newPlanName: paymentDetails?.last_plan_change?.to_plan,
                userCurrentPlanName: paymentDetails.plan_name,
                userCurrentDays: convertSecondsToDaysToDays(
                  paymentDetails?.end_date_in_seconds
                )
              })
            : translate("success-page_downgrade-paragraph_no-subscription", {
                newPlanName: paymentDetails?.last_plan_change?.to_plan,
                userCurrentPlanName: paymentDetails.plan_name,
                userCurrentDays: convertSecondsToDaysToDays(
                  paymentDetails?.end_date_in_seconds
                )
              })
        }}
      />
    </div>
  ) : null;
};

export default compose(withTranslations)(DowngradeInfo);
